import { useContext } from 'react';
import { GeoPositionContext } from './GeoPositionContext';
export const useGeoPosition = () => {
    const context = useContext(GeoPositionContext);
    if (!context) {
        throw new Error('useLocation must be used within a LocationProvider');
    }
    return context;
};
